import { CREATE_NOTE, GET_ORDER_BY_ID, GET_ORDERS } from './ApiConstants';
import api from './ApiHandler';

export const getOrderHistory = async (payload: any) => {
  return await api.get(GET_ORDERS, { params: payload });
};

export const getOrderHistoryByPage = async (payload: any) => {
  return await api.get(GET_ORDER_BY_ID, { params: { ...payload } });
};

export const createStoreNoteApi = async (payload: any) => {
  return await api.post(CREATE_NOTE, { ...payload });
};
